import React from 'react'

const About = () => {
    return (
        <div>
            <h1>About the Github Finder App</h1>
            <p>The purpose of this App is to allow users to Search Github Users.</p>
        </div>
    )
}

export default About
